import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Form, Radio } from "semantic-ui-react";

/**
 * Displays a group of radio buttons vertically positioned.
 * Vertical grouped radio buttons usually requires a lot of boilerplate like wrapping them inside a <Form.Field>
 * and then declaring a lot of repetitive properties like name, model, value, and compute when it's checked.
 */
const FormRadioGroup = observer(({ title, name, options, onChange }) => (
  <>
    <Form.Field>
      <label>{title}</label>
    </Form.Field>
    {options.map(option => (
      <Fragment key={option.id}>
        <Form.Field>
          <Radio
            className="form-radio-group-radio"
            name={name}
            label={option.label}
            value={option.value}
            checked={option.checked}
            onChange={() => onChange(name, option.value)}
          />
        </Form.Field>
      </Fragment>
    ))}
  </>
));

FormRadioGroup.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
      checked: PropTypes.bool,
    }),
  ),
};

export default FormRadioGroup;
